import * as yup from 'yup';

import {
  CHANNEL_DIRECTORY_TYPES,
  CHANNEL_DIRECTORY_TYPE,
} from 'constants-channel';

import { StringTypeBase } from '../../types/baseTypes/StringTypeBase';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use DirectoryType from application-types instead.
 */
export class DirectoryType extends StringTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Directory';

  friendlyName = 'Directory';

  contexts = [TypeContextEnum.Block];

  get example() {
    return CHANNEL_DIRECTORY_TYPE.Retail;
  }

  get default(): any {
    return CHANNEL_DIRECTORY_TYPE.Retail;
  }

  buildSchema() {
    return yup.string().nullable().oneOf(CHANNEL_DIRECTORY_TYPES);
  }
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Directory from application-types instead.
 */
const definition = new DirectoryType();

Types.addBaseType(definition);
export default definition;
